<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("recipeReport") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label :class="getRecipeReportsSelectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getRecipeReportsSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onRecipeReportDropDownHandler({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button @click="onFetchRecipeReports" class="btn-blue-lg w-100">
              {{ $tc("getReport") }}
            </button>
          </div>

          <div
          v-if="getRecipeReports.length > 0"
          class="col-lg-5 col-xl-6 align-self-center mb-4 d-flex justify-content-end align-items-end"
        >
          <div class="mr-1">{{ $t("download") }} as:</div>
          <a href="#" @click="generateReport()" title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>

          <a target="_blank" title="Download as Excel" @click="excelDownload()">
            <img src="@/assets/img/icons/excel.svg" class="mx-2" height="25" width="25" />
          </a>
        </div>

        </div>
      </div>

      <div class="swc-report">
        <vue-html2pdf
          :show-layout="true"
          :float-layout="false"
          :enable-download="false"
          paginate-elements-by-height="100%"
          :pdf-quality="2"
          :manual-pagination="true"
          pdf-format="a3"
          pdf-orientation="landscape"
          pdf-content-width="100%"
          @beforeDownload="beforeDownload($event)"
          ref="html2Pdf"
        >
          <table slot="pdf-content" class="swc-report-table" border="1">
            <thead class="bg-lightgrey">
              <tr>
                <th>{{ $tc("item") }} Code</th>
                <th>{{ $tc("item") }}</th>
                <th>Creation {{ $tc("date") }}</th>
                <th>{{ $tc("rawmaterial") }} Code</th>
                <th>{{ $tc("rawmaterials") }}</th>
                <th>{{ $tc("qty") }}.</th>
                <th>U.O.M</th>
                <th>{{ $tc("rate") }}</th>
                <th>{{ $tc("Cost Price") }}</th>
                <th>Recon.</th>
              </tr>
            </thead>
            <tbody v-if="getRecipeReports.length == 0">
              <tr>
                <td colspan="10">
                  <!-- <p class="text-center h6 mb-0">
                {{ $tc("NoRecords") }}
                </p> -->
                  <NoRecords />
                </td>
              </tr>
            </tbody>
            <tbody
              v-else-if="getRecipeReports.length > 0"
              v-for="(singleFnbItem, singleFnbItemIndex) in getRecipeReports"
              :key="singleFnbItemIndex"
              class="sph-report sph-report-thtd"
            >
              <tr>
                <td
                  :rowspan="singleFnbItem.ItemsList.length + 1"
                  class="text-left"
                >
                  {{ singleFnbItem.ItemsList[0].item_code }}
                </td>
                <td
                  :rowspan="singleFnbItem.ItemsList.length + 1"
                  class="text-left"
                >
                  {{ singleFnbItem.ItemsList[0].item_name }}
                </td>
                <td
                  :rowspan="singleFnbItem.ItemsList.length + 1"
                  class="text-left"
                >
                  {{ singleFnbItem.ItemsList[0].recipe_date | dateparse }}
                </td>
              </tr>
              <template
                v-for="(singleRawMaterial,
                singleRawMaterialKey) in singleFnbItem.ItemsList"
              >
                <tr :key="singleRawMaterialKey + singleFnbItemIndex + 123">
                  <td class="text-left">{{ singleRawMaterial.rm_code }}</td>
                  <td class="text-left">{{ singleRawMaterial.rm_name }}</td>
                  <td class="text-right">
                    {{ singleRawMaterial.ri_quantity }}
                  </td>
                  <td class="text-left">
                    {{ singleRawMaterial.uom_short_form }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(singleRawMaterial.singleItemPrice) }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        singleRawMaterial.ri_quantity *
                          singleRawMaterial.singleItemPrice
                      )
                    }}
                  </td>
                  <td v-if="singleRawMaterial.recco == 'Y'" class="text-left">
                    {{ singleRawMaterial.recco }}
                  </td>
                  <td v-else class="text-left">N</td>
                </tr>
              </template>
              <tr
                class="bg-lightgrey font-weight-bold"
                :key="singleFnbItemIndex + 22"
              >
                <!-- <td  class="text-left">Total</td> -->
                <td
                  :rowspan="singleFnbItem.ItemsList.length + 1"
                  class="text-left"
                >
                  {{ singleFnbItem.ItemsList[0].item_name }}
                </td>
                <td
                  :rowspan="singleFnbItem.ItemsList.length + 1"
                  class="text-left"
                >
                  {{ singleFnbItem.ItemsList[0].recipe_date | dateparse }}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-right">
                  {{ currFormat(singleFnbItem.ItemsList[0].itc_cost_price) }}
                </td>
                <td></td>
              </tr>
            </tbody>
            <!-- <tr class="bg-lightgrey font-weight-bold">
            <td colspan="6" class="text-left">Grand Total</td>
            <td class="text-right">
              {{ currFormat(grandTotalRecipeReport) }}
            </td>
            <td></td>
          </tr> -->
          </table>
        </vue-html2pdf>
      
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
import xlsx from "json-as-xlsx";
import NoRecords from "@/components/Partials/NoRecords.vue";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    NoRecords,
    VueHtml2pdf
  },
  data() {
    return {
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      searchCinema: "",
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 2,
        image: {
          type: "jpeg",
          quality: 0.98
        },
        html2canvas: {
          scale: 1,
          useCORS: true
        },
        jsPDF: {
          format: "a3",
          orientation: "landscape"
        }
      }
    };
  },

  computed: {
    ...mapGetters([
      "getCinemasList",
      "getRecipeReportsSelectedCinema",
      "getRecipeReports",

      // EXCEL
      "getRecipeReportsExcelFileName",
      // PDF
      "getRecipeReportsPDFFileName"
    ]),
    grandTotalRecipeReport() {
      let acc = 0;
      this.getRecipeReports.map(x => {
        x.ItemsList.map(y => {
          acc = acc + y.itc_cost_price;
        });
      });
      return acc;
    }
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    // this.fetchCinemasList({ cinemaId });
    this.ResetRecipeReport();

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    // if (CinemaObj) {
    //   this.onRecipeReportDropDownHandler({
    //     event: null,
    //     name: "isCinema",
    //     selectedItem: CinemaObj
    //   });
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onRecipeReportDropDownHandler({
    //       event: null,
    //       name: "isCinema",
    //       selectedItem: CinemaObj
    //     });
    //   }
    // }
  },
  methods: {
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const date = new Date();
      this.pdfFileName = "Reports" + date.getTime();
      this.htmlToPdfOptions.filename = this.pdfFileName;
      await html2pdf()
        .set(this.htmlToPdfOptions)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then(pdf => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(5);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },

    generateReport() {
      this.$refs.html2Pdf &&
        this.$refs.html2Pdf.generatePdf &&
        this.$refs.html2Pdf.generatePdf();
    },
    excelDownload() {
      let temp_data = this.getRecipeReports;
      let temp_arr = [];
      temp_data.map(x => {
        x.ItemsList.map(y => {
          let obj = {
            ...x,
            ...y
          };
          temp_arr.push(obj);
        });
      });
      let data = [
        {
          sheet: "Recipe Report",
          columns: [
            {
              value: "item_code",
              label: "Item Code"
            },
            {
              value: "item_name",
              label: "Item Name"
            },
            {
              value: "recipe_date",
              label: "Recipe Date"
            },
            {
              value: "rm_code",
              label: "Raw Material Code"
            },
            {
              value: "rm_name",
              label: "Raw Material Name"
            },
            {
              value: "ri_quantity",
              label: "Quantity"
            },
            {
              value: "uom_short_form",
              label: "U.O.M"
            },
            {
              value: "singleItemPrice",
              label: "Rate"
            },
            {
              value: row => (row.ri_quantity * row.singleItemPrice).toFixed(2),
              label: "Cost Price"
            },
            {
              value: row => (row.recco == "Y" ? row.recco : "N"),
              label: "Recon."
            }
            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,
            // total_taxes: 0,
            // final_gross_amount: 0
          ],
          content: temp_arr
        }
      ];
      let settings = {
        fileName: `ReceipeReport${new Date().getTime()}`
      };
      xlsx(data, settings);
    },
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
                this.onRecipeReportDropDownHandler({
                  name: "isCinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id
                  }
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "fetchCinemasList",
      "onRecipeReportDropDownHandler",
      "ResetRecipeReport",
      "onFetchRecipeReports"
    ])
  }
};
</script>

<style scoped>
.sph-report th,
td {
  /* height: 30px; */
}
.sph-report-thtd {
  border: 1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/receipeReportV2.vue